export default {"src":"/_next/static/media/recarding-preference-survey-logo.b74246a6.svg","height":132,"width":136,"blurWidth":0,"blurHeight":0};